
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import Spinner from 'vue-simple-spinner'
import Typography from '@/components/Rain/Typography/Typography.vue'

@Component<ReturningContactsLoading>({
    components: {
        Spinner,
        Typography,
    },
})
export default class ReturningContactsLoading extends Vue {
    @Prop({ type: Boolean, required: false, default: false })
    public readonly medium!: boolean
}
